import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import {
  AdminRole,
  StaffRole,
  UserRole,
} from '../../api/staff/lib/staff.interfaces';
import { ExtendedAuthService } from './auth.service';
import { AuthUser } from './auth.interfaces';

export const AdminGuard =
  (...roles: AdminRole[]): CanActivateFn =>
  () => {
    const router = inject(Router);
    const authService = inject(ExtendedAuthService);

    return authService.user$.pipe(
      map((user) =>
        isSystemAdministrator(user) ||
        user?.adminRoles?.some((role) => roles.includes(role))
          ? true
          : router.parseUrl('/'),
      ),
    );
  };

export const StaffGuard =
  (...roles: StaffRole[]): CanActivateFn =>
  () => {
    const router = inject(Router);
    const authService = inject(ExtendedAuthService);

    return authService.user$.pipe(
      map((user) =>
        isSystemAdministrator(user) ||
        user?.staffRoles?.some((role) => roles.includes(role))
          ? true
          : router.parseUrl('/'),
      ),
    );
  };

export function isSystemAdministrator(user?: AuthUser | null) {
  return (
    user?.role === UserRole.Administrator || user?.role === UserRole.Superuser
  );
}
